<template>
    <form-container :headerText="title" :width="800" action="editVerein"
                    :valid-actions="['editVerein']" @save="save()" :hide-actions="readOnly">
        <div v-if="rules" class="px-7 pb-3">
            <v-row no-gutters align="center">
                <v-col cols="12" sm="3">
                    <v-text-field v-model="dataObject.id" :rules="[rules.required]"
                                  label="Vereinsnummer" :disabled="currentData!==null"/>
                </v-col>
                <v-col cols="12" sm="9" :class="[{'pl-4': $vuetify.breakpoint.smAndUp}]">
                    <v-text-field v-model="dataObject.name" :rules="[rules.required]" :readonly="readOnly"
                                  label="Vereinsname"/>
                </v-col>
                <v-col cols="12" sm="6" :class="[{'pr-2': $vuetify.breakpoint.smAndUp}]">
                    <div class="primary--text subtitle-2 font-weight-bold">Vereinssitz</div>
                    <v-text-field v-model="dataObject.vereinsSitz.name" :rules="rulesDynamic"
                                  label="Name des Vereinssitzes" :readonly="readOnly"/>
                    <v-text-field v-model="dataObject.vereinsSitz.strasse" :rules="rulesDynamic"
                                  label="Straße" :readonly="readOnly"/>
                    <v-row no-gutters>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="dataObject.vereinsSitz.plz" :rules="rulesDynamic"
                                          label="Plz" :readonly="readOnly"/>
                        </v-col>
                        <v-col cols="12" sm="9" :class="[{'pl-4': $vuetify.breakpoint.smAndUp}]">
                            <v-text-field v-model="dataObject.vereinsSitz.ort" :rules="rulesDynamic"
                                          label="Ort" :readonly="readOnly"/>
                        </v-col>
                    </v-row>
                    <v-text-field v-model="dataObject.vereinsSitz.telefon" :rules="rulesDynamic"
                                  label="Telefon" :readonly="readOnly"/>
                    <v-text-field v-model="dataObject.vereinsSitz.email" :rules="rulesDynamic"
                                  label="E-Mail" :readonly="readOnly"/>
                </v-col>
                <v-col cols="12" sm="6" :class="[{'pl-2': $vuetify.breakpoint.smAndUp}]">
                    <div class="primary--text subtitle-2 font-weight-bold">ZVR Nummer</div>
                    <v-text-field v-model="dataObject.zvrNr" :rules="rulesDynamic" label="ZVR-Nummer" :readonly="readOnly"/>
                    <div :class="[{'mt-12': $vuetify.breakpoint.smAndUp}, 'primary--text subtitle-2 font-weight-bold']">
                        Abweichende Zustelladresse</div>
                    <v-text-field v-model="dataObject.postZustellAdresse.name" label="Name der Zustelladresse" :readonly="readOnly"/>
                    <v-text-field v-model="dataObject.postZustellAdresse.strasse" label="Straße" :readonly="readOnly"/>
                    <v-row no-gutters>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="dataObject.postZustellAdresse.plz" label="Plz" :readonly="readOnly"/>
                        </v-col>
                        <v-col cols="12" sm="9" :class="[{'pl-4': $vuetify.breakpoint.smAndUp}]">
                            <v-text-field v-model="dataObject.postZustellAdresse.ort" label="Ort" :readonly="readOnly"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12">
                    <div class="primary--text subtitle-2 font-weight-bold">Bankverbindung</div>
                </v-col>
                <v-col cols="12" sm="3" :class="[{'pr-2': $vuetify.breakpoint.smAndUp}]">
                    <v-text-field v-model="dataObject.bankVerbindung.inhaber" :rules="rulesDynamic"
                                  label="Inhaber" :readonly="readOnly"/>
                </v-col>
                <v-col cols="12" sm="3" :class="[{'pl-2': $vuetify.breakpoint.smAndUp}]">
                    <v-text-field v-model="dataObject.bankVerbindung.institut" :rules="rulesDynamic"
                                  label="Bankname" :readonly="readOnly"/>
                </v-col>
                <v-col cols="12" sm="6" :class="[{'pl-2': $vuetify.breakpoint.smAndUp}]">
                    <v-text-field v-model="dataObject.bankVerbindung.iban" :rules="rulesDynamic"
                                  label="IBAN" :readonly="readOnly"/>
                </v-col>
                <v-col class="grow">
                    <div class="primary--text subtitle-2 font-weight-bold">Status</div>
                </v-col>
                <v-col class="shrink text-no-wrap">
                    <v-checkbox v-model="dataObject.inaktiv" label="Verein ist inaktiv"/>
                </v-col>
            </v-row>
            <v-alert icon="mdi-information" text v-if="readOnly">
                Für Änderungen der Vereinsdaten wende dich bitte an den ÖSKB Passreferenten!
            </v-alert>
            <error-msg :error="error"></error-msg>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "../../components/form/formContainer";
    import {FormRules} from "@/services/formRules";
    import ErrorMsg from "../../components/elements/errorMsg";

    export default {
        components: { ErrorMsg, FormContainer},
        name: "verein-edit",
        props: ['currentData', 'landesverband'],
        data: () => ({
            rules: null,
            dataObject: null,
            error: ''
        }),
        computed: {
            title(){ return this.readOnly ? 'Vereinsdaten' : this.currentData ? 'Vereinsdaten ändern' : 'Verein anlegen'},
            user(){ return this.$store.state.user },
            readOnly(){ return !this.user.permissions.pass },
            rulesDynamic(){ return this.dataObject.inaktiv ? [] : [this.rules.required] }
        },
        created(){
            this.rules = new FormRules();
            this.resetDataObject()
        },
        methods: {
            async save(){
                if ( !this.currentData && this.landesverband.vereine[this.dataObject.id] ) {
                    this.error = 'Diese Vereinsnummer ist bereits vergeben, bitte wähle eine andere!';
                    return;
                }
                const dataObject = JSON.parse(JSON.stringify(this.dataObject))
                delete dataObject.id
                this.landesverband.local.documentUpdates = {
                    ['vereine.' + this.dataObject.id]: dataObject,
                };
                let reply = await this.landesverband.saveEdited();
                if ( reply.successful ) {
                    if ( this.currentData ) {
                        this.$emit('changeVerein', this.dataObject);
                    }
                    this.resetDataObject();
                    window.history.back();
                }
            },
            resetDataObject(){
                this.dataObject = {
                    id: null,
                    name: '',
                    vereinsSitz: {
                        name: '',
                        strasse: '',
                        plz: '',
                        ort: '',
                        telefon: '',
                        email: '',
                    },
                    postZustellAdresse: {
                        name: '',
                        strasse: '',
                        plz: '',
                        ort: '',
                    },
                    zvrNr: '',
                    bankVerbindung: {
                        inhaber: '',
                        institut: '',
                        iban: '',
                    },
                    inaktiv: false,
                };
                this.error = '';
            },
            setFromCurrentData(){
                this.resetDataObject()
                const currentData = JSON.parse(JSON.stringify(this.currentData))
                console.log ("currentData", currentData);
                this.dataObject.id = currentData.id;
                this.dataObject.name = currentData.name;
                this.dataObject.zvrNr = currentData.zvrNr ? currentData.zvrNr : this.dataObject.zvrNr;
                this.dataObject.vereinsSitz = currentData.vereinsSitz ? currentData.vereinsSitz : this.dataObject.vereinsSitz;
                this.dataObject.postZustellAdresse = currentData.postZustellAdresse ? currentData.postZustellAdresse :
                                            this.dataObject.postZustellAdresse;
                this.dataObject.bankVerbindung = currentData.bankVerbindung ? currentData.bankVerbindung :
                                            this.dataObject.bankVerbindung;
                this.dataObject.inaktiv = currentData.inaktiv !== undefined ? currentData.inaktiv : false
            }
        },
        watch: {
            currentData(to, from){
                if ( (this.currentData || to !== from) && to) {
                    this.setFromCurrentData()
                } else {
                    this.resetDataObject();
                }
            }
        }

    }
</script>

<style scoped>

</style>